import { FigmaTypography } from "./figma-typography";
import { cn } from "../../../lib/utils";
export function InputLabel({
  children,
  className,
  isOptional = false
}: {
  children: string;
  className?: string;
  isOptional?: boolean;
}) {
  return (
    <FigmaTypography variant="label-2" className={cn("flex gap-2 items-center", className)}>
      {children}
      {isOptional && (
        <FigmaTypography component="span" variant="body-3" color="zinc400" className="font-light">
          Optional
        </FigmaTypography>
      )}
    </FigmaTypography>
  );
}
